import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getPaginatedPayments,
    getPaginatedSubscriptions,
} from "../../Reducers/actions/paymentActions";
import Skeleton from "../../components/Skeleton/Skeleton";
import {
    PaymentSummaryRowSkeleton,
    SubscriptionSummaryRowSkeleton,
} from "../../components/Skeletons/FinanceListSkeletons";
import { setTopNavbar } from "../../Reducers/actions/navbarActions";

import "./PaymentHistory.scss";
import SubscriptionSummary from "./SubscriptionSummary";
import { useNavigate } from "react-router-dom";
import PaymentSummary from "./PaymentSummary";
import Icon from "../../components/Icon/Icon";

function PaymentHistoryScreenSkeleton() {
    return (
        <div className="main-container px-16" role="status" aria-label="Loading payment history">
            <div className="subscription-container">
                <Skeleton width="240px" height="22px" borderRadius="8px" className="m-0 p-0 mb-16" />
                {[1, 2].map((i) => (
                    <SubscriptionSummaryRowSkeleton key={i} />
                ))}
            </div>
            <div className="payments-container mt-24">
                <Skeleton width="200px" height="22px" borderRadius="8px" className="m-0 p-0 mb-16" />
                {[1, 2, 3, 4].map((i) => (
                    <PaymentSummaryRowSkeleton key={i} />
                ))}
            </div>
        </div>
    );
}

function PaymentHistory() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {
        auth_user_id,
        subscriptionsLoading,
        subscriptions,
        payments,
        paymentsLoading,
    } = useSelector((state) => ({
        auth_user_id: state.auth.user?.user_id,
        subscriptions: state?.payments?.subscriptions,
        subscriptionsLoading: state?.payments?.subscriptionsLoading,
        paymentsLoading: state?.payments?.loading,
        payments: state?.payments?.payments,
    }));

    useEffect(() => {
        dispatch(setTopNavbar({ showBackArrow: true, title: "Payment History" }));
        if (!auth_user_id) return;
        dispatch(getPaginatedSubscriptions(0, 10, auth_user_id));
        dispatch(getPaginatedPayments(0, 10, auth_user_id));
    }, [auth_user_id]);

    const handleViewContributions = () => {
        navigate("/payments-history/contributions");
    };
    const handleViewAllTransactions = () => {
        navigate("/payments-history/transactions");
    };

    if (subscriptionsLoading || paymentsLoading) {
        return <PaymentHistoryScreenSkeleton />;
    }

    return (
        <div className="main-container px-16">
            <div className="subscription-container">
                <div className="d-flex f-row aifs" onClick={handleViewContributions} style={{cursor: 'pointer'}}>
                    <p className="fg-dark fs-xm2 fw-bold d-flex f-row">Monthly Contributions
                        <Icon alias={"arrow_expand"} color={"none"} stroke={"#FF3232"} height={24} width={24} />
                    </p>
                </div>
                {subscriptions?.length === 0 && (
                    <div className="empty-subscriptions py-32">You have no subscriptions</div>
                )}
                {subscriptions?.map((subscription) => (
                    <SubscriptionSummary
                        subscription={subscription}
                    />
                ))}
            </div>
            <div className="payments-container mt-24">
                <div className="d-flex aic jcsb mb-8">
                    <div className="d-flex f-row aifs" onClick={handleViewAllTransactions} style={{cursor: 'pointer'}}>
                        <p className="fg-dark fs-xm2 fw-bold d-flex f-row">Recent payments
                            <Icon alias={"arrow_expand"} color={"none"} stroke={"#FF3232"} height={24} width={24} />
                        </p>
                    </div>


                </div>
                {payments.map((payment) => (
                    <PaymentSummary key={payment?.id} payment={payment} variant="paymentHistory" />
                ))}
            </div>
        </div>
    );
}

export default PaymentHistory;
